import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

export const options = [
  { label: 'Unset', value: '' },
  { label: 'Normal', value: 'default' },
  { label: 'Low', value: 'low' },
  { label: 'High', value: 'high' },
  { label: 'Excluded', value: 'never' },
]

interface Props {}

export default function MigrationPriorityPicklist({
  name = 'priority',
  label = 'Migration Priority',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
